"use client";

export interface EditorTopBarProps {
  source: "trip" | "public";
  totalSlides: number;
  onExportClick: () => void;
  exportDisabled: boolean;
  /** Present when the editor is an in-page overlay (not its own route) — lets the user back out to whatever opened it. */
  onClose?: () => void;
}

export default function EditorTopBar({ source, totalSlides, onExportClick, exportDisabled, onClose }: EditorTopBarProps) {
  return (
    <div className="ced-topbar">
      {onClose && (
        <button type="button" className="ced-topbar-close" onClick={onClose} aria-label="Close editor">
          ← Back
        </button>
      )}
      <span className="ced-topbar-brand">
        <svg width="16" height="16" viewBox="0 0 22 22" fill="none" aria-hidden="true">
          <circle cx="11" cy="11" r="9" stroke="currentColor" strokeWidth="1.6" />
          <circle cx="11" cy="11" r="5" stroke="currentColor" strokeWidth="1.6" />
          <circle cx="11" cy="11" r="1.8" fill="currentColor" />
        </svg>
        Carousel Studio
      </span>
      <span className="ced-topbar-sep" aria-hidden="true" />
      <span className="ced-topbar-crumb">
        {totalSlides} slide{totalSlides === 1 ? "" : "s"}{source === "trip" ? " · from this trip" : ""}
      </span>
      <span className="ced-topbar-spacer" />
      <button type="button" className="ced-topbar-export" onClick={onExportClick} disabled={exportDisabled}>
        Export carousel
      </button>
    </div>
  );
}
